import PFileUpload from './utils/file-upload'
import ManageFormFieldVisibility from './helpers/manage-form-field-visibility'



const fileUploads = document.querySelectorAll('.file-upload-container')

const formUploads = []

if(fileUploads) {

  fileUploads.forEach(fileUpload => {
    let formUpload = new PFileUpload(fileUpload)
    formUploads.push(formUpload)
  })

}

const formSwitches = document.querySelectorAll('.form-field-switch')
const formBlocks = document.querySelectorAll('.form-block[data-form]')

formSwitches.forEach((field) => {
  const radio = field.querySelector('input[type="radio"]')

  if(!radio) return false;

  radio.addEventListener('change', () => {
    const value = radio.getAttribute('data-form-switch')
    const checked = radio.checked

    if(checked) {
      switchFormBlock(value)
    }

  })

})


function switchFormBlock(radioValue) {

  formBlocks.forEach((block) => {

    block.setAttribute('data-visible', 'false')

    if(block.getAttribute('data-form') === radioValue) {
      block.setAttribute('data-visible', 'true')
    }

  })

}


// email validation
function validEmail (e) {
  let filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
  return String(e).search(filter) !== -1
}


function isValidForm(form)
{
  let valid = 1

  form.find('.form-field-input.form-field-mandatory').each(function (){
    if($(this).hasClass('d-none')) return;
    if($(this).find('input').val().length <= 2) {
      valid = 0
      $(this).addClass('has-error')
    }
  })

  form.find('.form-field-email').each(function (){
    if($(this).hasClass('d-none')) return;
    if(!validEmail($(this).find('input').val())) {
      valid = 0
      $(this).addClass('has-error')
    }
  })

  form.find('.form-field-textarea.form-field-mandatory').each(function (){
    if($(this).hasClass('d-none')) return;
    if($(this).find('textarea').val().length <= 3) {
      valid = 0
      $(this).addClass('has-error')
    }
  })

  form.find('.form-field-checkbox.form-field-mandatory').each(function (){
    if($(this).hasClass('d-none')) return;
    if(!$(this).find('input').is(':checked')) {
      valid = 0
      $(this).addClass('has-error')
    }
  })


  return valid
}

function toggleButtonLoader(svg, loader)
{
  svg.classList.toggle('d-none');
  loader.classList.toggle('d-none');
}

const forms = document.querySelectorAll('.generated-form')

forms.forEach((form) => {

  new ManageFormFieldVisibility(form)

  form.addEventListener('submit', (e) => {
    e.preventDefault()

    const formSubmitBtn = form.querySelector('.form-field-submit')
    const formWrapper = form.closest('.form-wrapper')

    if(!formSubmitBtn) return;

    const formSubmitBtnSvg = formSubmitBtn.querySelector('svg')
    const formSubmitBtnLoader = formSubmitBtn.querySelector('.loader')

    toggleButtonLoader(formSubmitBtnSvg, formSubmitBtnLoader);

    const formError = form.querySelector('.form-results-error')
    const validForm = isValidForm($(form))

    formError.classList.add('d-none')

    if(!validForm) {
      formError.classList.remove('d-none')
      toggleButtonLoader(formSubmitBtnSvg, formSubmitBtnLoader);

      return false
    }

    // remove hidden fields
    const hiddenFields = form.querySelectorAll('.form-field.d-none')
    if(hiddenFields) {
      hiddenFields.forEach(field => {
        field.remove()
      })
    }


    const formData = getFormData(e.target)


    const formSuccess = form.querySelector('.form-results-success')
    const formRows = formWrapper.querySelectorAll('.form-row')

    $.ajax({
      type: 'POST',
      url: localize_script.admin_ajax,
      data: formData,
      async: false,
      cache: false,
      contentType: false,
      enctype: 'multipart/form-data',
      processData: false,
      success: function (results) {

        toggleButtonLoader(formSubmitBtnSvg, formSubmitBtnLoader);

        formSuccess.classList.remove('d-none');

        formRows.forEach((formRow) => {
          formRow.classList.add('d-none');
        });

        formSubmitBtn.classList.add('d-none');

        formSuccess.scrollIntoView();


      },
    })

  })

  function getFormData(target) {

    let formData = new FormData(target)

    if(formUploads.length > 0) {
      formUploads.forEach(formUpload => {
        const files = formUpload.getUploadedFiles()
        const name = formUpload.getUploadedName()
        if(files && files.length) {
          files.forEach(file => {
            formData.append(name + '[]', file)
          })
        }
      })
    }


    return formData;

  }

})
